import React, { Component } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Alert } from "@material-ui/lab";
import Swal from "sweetalert2";
import { withRouter } from "react-router";
import { Paper } from "@material-ui/core";
import moment from "moment";

class ManualTransaction extends Component {

  constructor(props) {
    super(props);

    const url_array = document.location.href.split("/"); //get the url

    this.state = {
      subject_lcf_id: url_array[url_array.length - 1],
      amount: "",
      trx_type: "manual",
      date: "",
      pay_day_date: null,
      comment: "",
      error: false
    };
  }

  render() {
    return (
      <>
        {this.state.error === true && (
          <Alert className="error" style={{}} severity="error">
            Please fill out all of the required fields
          </Alert>
        )}

        <center>
          <h1>Create a Manual Transaction</h1>
        </center>

        <Paper
          elevation={5}
          style={{ width: "90%", margin: "3% auto", padding: "2%" }}
        >
          <Form>
            <Row>
              <Col>
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  placeholder="Enter the Amount"
                  type="number"
                  name="amount"
                  value={this.state.amount}
                  onChange={this.handleInputChangeFor("amount")}
                />
              </Col>
              <Col>
                <Form.Label>Custom Date (Optional)</Form.Label>
                <Form.Control
                  placeholder="None"
                  type="date"
                  name="transaction_date"
                  value={this.state.date}
                  onChange={this.handleInputChangeFor("date")}
                />
                {this.farOffDate() === true && (
                  <Alert severity="warning">
                    Warning: The date you entered is more than 90 days away
                    from the current date.
                  </Alert>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
              <Form.Label>Comment</Form.Label>
                <Form.Control
                  placeholder="Optional Brief Details"
                  type="text"
                  name="comment"
                  value={this.state.comment}
                  onChange={this.handleInputChangeFor("comment")}
                />
              </Col>
            </Row>
            <center>
              <Button
                onClick={(event) => this.createTransaction(event)}
                variant="success"
                type="submit"
                style={{ width: "20%", marginTop: "2%" }}
              >
                Create New Transaction
              </Button>
            </center>
          </Form>
        </Paper>
      </>
    );
  }

  //This function handles storing input values into state on change
  handleInputChangeFor = (propertyName) => (event) => {
    this.setState({
      [propertyName]: event.target.value,
    });
  };

  farOffDate = () => {
    const daysDiff = moment().diff(this.state.date, 'days');
    return (daysDiff > 90 || daysDiff < -90);
  }

  async createTransaction(event) {
    event.preventDefault();

    if (!this.state.amount) {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 5000);
      return;
    }

    const {  // create our variables for Swal
      subject_lcf_id,
      amount,
      trx_type,
      pay_day_date,
      comment,
    } = this.state;

    const date = this.state.date ? moment(this.state.date) : moment();

    const confirm =  await Swal.fire({
      title: "Please confirm the transaction details below",
      html: `1. LCF ID: ${subject_lcf_id} </br>
        2. Amount: ${amount} </br>
        3. Date: ${date.format("MM-DD-YYYY")} </br>
        4. Comment: ${comment}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#5cb85c",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm Transaction",
    });

    if (!confirm.value) {
      return;
    }
    axios.post(`/api/admin/manual-transaction/`,
      {
        lcf_id: subject_lcf_id,
        amount: amount,
        trx_type: trx_type,
        pay_day_date: pay_day_date,
        created_at: date.utc(),
        comment: comment,
      })
      .then(() => {
        Swal.fire("Success!", "Your new transaction has been created.", "success");
        this.props.history.push(`/transaction-history/${this.state.subject_lcf_id}`);
      })
      .catch((error) => {
        console.log("Error sending transaction to server.", error);
      });
  }
}


export default ManualTransaction;